import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import RelatedUserSection from "./RelatedUserSection";

const OpenAIAdminAPIKeyDetailsView = ({ entityData }) => {
  const ownerType = entityData?.openai_admin_api_key_data?.owner_type;
  const ownerName = entityData?.openai_admin_api_key_data?.owner_name;

  return (
    <Box display={"flex"} flexDirection={"column"} gap={1.5}>
      {ownerType === "user" && entityData?.connected_email && (
        <RelatedUserSection
          entityData={entityData}
          contextName="OpenAI admin API key details view"
        />
      )}
      {entityData?.openai_admin_api_key_data?.name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Name</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData.openai_admin_api_key_data.name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {ownerName && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Owner</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
            {(ownerType !== "user" || !entityData?.connected_email) && (
              <TextIntegrationStyle
                title={"Name"}
                value={ownerName}
              ></TextIntegrationStyle>
            )}
            {ownerType && (
              <TextIntegrationStyle
                title={"Type"}
                value={ownerType === "user" ? "User" : "Service Account"}
              ></TextIntegrationStyle>
            )}
            {entityData?.openai_admin_api_key_data?.owner_role && (
              <TextIntegrationStyle
                title={"Role"}
                value={entityData.openai_admin_api_key_data.owner_role}
              ></TextIntegrationStyle>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default OpenAIAdminAPIKeyDetailsView;
